/**
 * Required wherever HM Land Registry Price Paid Data is used or published. The
 * wording is prescribed, including the year, at
 * https://www.gov.uk/government/statistical-data-sets/price-paid-data-downloads
 * Plain constants: the site footer and the static page renderers both import this.
 */
export const PRICE_PAID_ATTRIBUTION_LEAD =
  'Contains HM Land Registry data © Crown copyright and database right 2021. This data is licensed under the '
export const OGL_LICENCE_NAME = 'Open Government Licence v3.0'
export const OGL_LICENCE_URL = 'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/'

/** For the static renderers, which build HTML strings. The text has nothing to escape beyond the copyright sign. */
export const PRICE_PAID_ATTRIBUTION_HTML = `${PRICE_PAID_ATTRIBUTION_LEAD}<a href="${OGL_LICENCE_URL}" rel="license noopener" target="_blank">${OGL_LICENCE_NAME}</a>.`
